import { keyframes } from "@mui/material/styles";

export const luxeGradientShift = keyframes`
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
`;

export const luxeFloat = keyframes`
  0%, 100% { transform: translateY(0) rotate(0deg) scale(1); }
  50% { transform: translateY(-30px) rotate(8deg) scale(1.05); }
`;

export const LUXE_ACCENT = "#FF4D6D";
